import { Phone } from "lucide-react";
import { SiViber, SiWhatsapp, SiTelegram, SiSignal } from "react-icons/si";
import { CONTACT } from "@/data/content";

const channels = [
  { key: "viber", href: CONTACT.viber, label: "Viber", color: "#7360F2", Icon: SiViber },
  { key: "whatsapp", href: CONTACT.whatsapp, label: "WhatsApp", color: "#25D366", Icon: SiWhatsapp },
  { key: "telegram", href: CONTACT.telegram, label: "Telegram", color: "#229ED9", Icon: SiTelegram },
  { key: "signal", href: CONTACT.signal, label: "Signal", color: "#3A76F0", Icon: SiSignal },
];

export const MessengerRow = ({ size = "md" }) => {
  const dim = size === "sm" ? "h-10 w-10" : "h-12 w-12";
  const ic = size === "sm" ? "h-[18px] w-[18px]" : "h-5 w-5";
  return (
    <div className="flex items-center gap-2.5" data-testid="messenger-row">
      {channels.map((c) => (
        <a
          key={c.key}
          href={c.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={c.label}
          data-testid={`messenger-${c.key}`}
          className={`${dim} flex items-center justify-center rounded-full border border-white/15 bg-white/5 transition-colors hover:bg-white/10`}
          style={{ color: c.color }}
        >
          <c.Icon className={ic} />
        </a>
      ))}
    </div>
  );
};

export const PhoneLink = ({ className = "" }) => (
  <a
    href={`tel:${CONTACT.phoneRaw}`}
    data-testid="phone-link"
    className={`inline-flex items-center gap-2 font-semibold tracking-wide ${className}`}
  >
    <Phone className="h-4 w-4 text-[#B12A2A]" strokeWidth={2.4} />
    {CONTACT.phoneDisplay}
  </a>
);
